import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL

if (!API_URL) { console.error("❌ API URL is missing"); }

const publicApi = axios.create({
  baseURL: `${API_URL}`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'client-type': 'web',
  },
  timeout: 30000,
});

export default publicApi;